export const fr = {
  // Header
  filiales: "Filiales",
  contact: "Contact",
  
  // Hero Section
  heroTitle: "Structurer et développer ",
  heroTitle2: " un écosystème d'entreprises",
  heroTitle3: " complémentaires.",
  heroDescription: "MSIT Corporate est un groupe pluridisciplinaire qui fédère et pilote ",
  heroDescription2: " plusieurs entreprises expertes dans le conseil, le digital,",
  heroDescription3: "le portage salarial et les espaces professionnels.",
  
  // Groupe Section
  groupeTitle: "1 Groupe",
  groupeSubtitle: "4 Filiales",
  groupeDescription: "complémentaires unies par une même mission : mettre l'expertise au service de votre évolution",
  spotinTitle: "Spotin",
  spotinDescription: "Des espaces modernes et inspirants pour travailler, collaborer et booster votre créativité",
  buzztrackTitle: "Buzztrack",
  buzztrackDescription: "Une équipe dédiée pour créer votre identité digitale, booster votre visibilité et maximiser vos opportunités.",
  msitConseilTitle: "Msit Conseil",
  msitConseilDescription: "Des conseils stratégiques sur mesure pour transformer vos ambitions en résultats concrets.",
  matoisTitle: "Matois",
  matoisDescription: "La liberté de travailler en toute sécurité avec un accompagnement administratif et financier complet.",
  
  // Corporate Stats
  corporateStatsTitle: "Msit Corporate",
  corporateStatsSubtitle: "en chiffres",
  stats1Number: "+4",
  stats1Label: "filiales complémentaires",
  stats2Number: "50+",
  stats2Label: "collaborateurs et partenaires",
  stats3Number: "70",
  stats3Label: "Projets réalisés",
  
  // Coworking Section
  matoisCoworkingTitle: "Matois",
  matoisCoworkingText1: "Portage salarial simplifié et sécurisé",
  matoisCoworkingText2: "Solutions flexibles pour indépendants",
  matoisCoworkingText3: "Gestion RH et administrative intégrée",
  msitConseilCoworkingTitle: "Msit conseil",
  msitConseilCoworkingText1: "Conseil en stratégie & systèmes d'information",
  msitConseilCoworkingText2: "Accompagnement à la transformation digitale",
  msitConseilCoworkingText3: "Expertise métier & technique",
  msitConseilCoworkingText4: "Vision stratégique",
  buzzTrackCoworkingTitle: "Buzz Track",
  buzzTrackCoworkingText1: "Agence marketing & communication 360°",
  buzzTrackCoworkingText2: "Création de sites web performants",
  buzzTrackCoworkingText3: "Stratégies digitales sur mesure",
  buzzTrackCoworkingText4: "Croissance et visibilité de marque",
  spotinCoworkingTitle: "Spotin",
  spotinCoworkingText1: "Espaces de coworking modernes et flexibles",
  spotinCoworkingText2: "Bureaux privés & open spaces design",
  spotinCoworkingText3: "Services professionnels tout inclus",
  
  // Contact Section
  contactTitle: "Des questions ?",
  contactSubtitle: "Nous avons les réponses.",
  contactNamePlaceholder: "Nom & Prénom",
  contactEmailPlaceholder: "Adresse e-mail",
  contactMessagePlaceholder: "Message",
  contactAcceptText: "J'accepte les termes et conditions de la",
  contactPrivacyPolicy: "politique de confidentialité.",
  contactSubmitButton: "Envoyer",
  contactSuccessMessage: "✅ Message envoyé avec succès !",
  contactErrorMessage: "❌ Erreur lors de l'envoi du message.",
  contactNetworkError: "📡 Impossible d'envoyer le message.",
  
  // Footer
  home: "Accueil",
  msitCorporate: "MSIT CORPORATE",
  msitAdvisory: "MSIT ADVISORY",
  buzzTrack: "Buzz track",
  spotIn: "Spot'in",
  allRightsReserved: "© 2006-2025, MSIT CORPORATE. Tous droits réservés",
  privacyPolicy: "Politique de confidentialité",
  cookiesPolicy: "Politique des cookies",
  
  // Cookies Policy
  cookiesTitle: "Politique des cookies",
  cookiesLastUpdated: "Dernière mise à jour :",
  cookiesLead: "Cette Politique des cookies explique comment MSIT Corporate utilise les cookies et technologies similaires sur notre site web.",
  cookiesWhatAre: "1. Que sont les cookies ?",
  cookiesWhatAreText: "Les cookies sont de petits fichiers texte placés sur votre appareil lorsque vous visitez un site web. Ils nous aident à améliorer votre expérience utilisateur et les performances de notre site web.",
  cookiesTypes: "2. Types de cookies que nous utilisons",
  cookiesEssential: "Cookies essentiels :",
  cookiesEssentialText: "Nécessaires au bon fonctionnement du site web.",
  cookiesAnalytics: "Cookies d'analyse :",
  cookiesAnalyticsText: "Nous aident à comprendre comment les visiteurs utilisent notre site (ex. Google Analytics).",
  cookiesFunctional: "Cookies fonctionnels :",
  cookiesFunctionalText: "Mémorisent vos préférences et améliorent la facilité d'utilisation.",
  cookiesMarketing: "Cookies marketing :",
  cookiesMarketingText: "Utilisés pour diffuser des publicités ou du contenu pertinents (uniquement avec votre consentement).",
  cookiesHowWeUse: "3. Comment nous utilisons les cookies",
  cookiesUse1: "Assurer le bon fonctionnement du site web.",
  cookiesUse2: "Analyser le trafic et améliorer l'expérience utilisateur.",
  cookiesUse3: "Personnaliser le contenu et mémoriser vos préférences.",
  cookiesManaging: "4. Gestion des cookies",
  cookiesManagingText: "Vous pouvez gérer ou désactiver les cookies via les paramètres de votre navigateur. Veuillez noter que la désactivation des cookies essentiels peut affecter le fonctionnement du site web.",
  cookiesManagingDetails: "Pour plus de détails, visitez :",
  cookiesUpdates: "5. Mises à jour de cette politique",
  cookiesUpdatesText: "Nous pouvons réviser cette Politique des cookies périodiquement. Tous les changements seront publiés sur cette page avec la date de mise à jour.",

  // Privacy Policy
  privacyTitle: "Politique de confidentialité",
  privacyLastUpdated: "Dernière mise à jour :",
  privacyLead: "MSIT Corporate s'engage à protéger et respecter votre vie privée. Cette Politique de confidentialité explique comment nous collectons, utilisons et protégeons vos données personnelles lorsque vous visitez notre site web ou interagissez avec nos services.",
  privacyInformation: "1. Informations que nous collectons",
  privacyInformationText: "Nous pouvons collecter les types d'informations suivants :",
  privacyPersonalInfo: "Informations personnelles :",
  privacyPersonalInfoText: "telles que nom, adresse e-mail, numéro de téléphone et détails de l'entreprise, lorsque vous nous contactez ou remplissez un formulaire.",
  privacyTechnicalData: "Données techniques :",
  privacyTechnicalDataText: "y compris l'adresse IP, le type de navigateur, les informations sur l'appareil et les pages visitées.",
  privacyUsageData: "Données d'utilisation :",
  privacyUsageDataText: "détails sur votre activité de navigation et interaction avec notre site web.",
  privacyHowWeUse: "2. Comment nous utilisons vos informations",
  privacyHowWeUseText: "Nous traitons vos données personnelles pour :",
  privacyUse1: "Fournir, exploiter et améliorer nos services.",
  privacyUse2: "Répondre à vos demandes et demandes de communication.",
  privacyUse3: "Envoyer des mises à jour commerciales ou du matériel marketing (uniquement avec votre consentement).",
  privacyUse4: "Se conformer aux obligations légales et réglementaires.",
  privacyLegalBasis: "3. Base légale du traitement",
  privacyLegalBasisText: "Nous traitons vos données sous une ou plusieurs des bases légales suivantes :",
  privacyConsent: "Votre consentement.",
  privacyContract: "Exécution d'un contrat.",
  privacyLegalObligations: "Conformité aux obligations légales.",
  privacyLegitimateInterests: "Nos intérêts commerciaux légitimes (tels que l'amélioration des services et des performances du site web).",
  privacyRetention: "4. Conservation des données",
  privacyRetentionText: "Nous conservons vos données uniquement le temps nécessaire pour accomplir les objectifs décrits dans cette politique, sauf si une période de conservation plus longue est requise par la loi.",
  privacySharing: "5. Partage et transfert de données",
  privacySharingText: "Nous ne vendons pas vos données personnelles. Nous pouvons partager des informations avec :",
  privacySubsidiaries: "Nos filiales et entités affiliées (MSIT Advisory, Buzztrack, Matois, Spotin).",
  privacyServiceProviders: "Des prestataires de services qui nous aident à exploiter notre site web et nos services.",
  privacyLegalAuthorities: "Les autorités légales si requis par la loi applicable.",
  privacySecurity: "6. Sécurité des données",
  privacySecurityText: "Nous utilisons des mesures techniques et organisationnelles conformes aux standards de l'industrie pour protéger vos informations contre l'accès non autorisé, la perte, l'utilisation abusive ou l'altération.",
  privacyRights: "7. Vos droits",
  privacyRightsText: "Sous le RGPD, vous avez le droit de :",
  privacyRights1: "Accéder, rectifier ou effacer vos données personnelles.",
  privacyRights2: "Restreindre ou vous opposer au traitement.",
  privacyRights3: "Retirer votre consentement à tout moment.",
  privacyRights4: "Portabilité des données.",
  privacyRightsContact: "Pour exercer vos droits, contactez-nous à :",
  privacyThirdParty: "8. Liens tiers",
  privacyThirdPartyText: "Notre site web peut contenir des liens vers des sites web tiers. Nous ne sommes pas responsables des pratiques de confidentialité de ces sites.",
  privacyUpdates: "9. Mises à jour de cette politique",
  privacyUpdatesText: "Nous pouvons mettre à jour cette Politique de confidentialité de temps à autre. Les changements seront publiés sur cette page avec la date de mise à jour.",

  // Common
  loading: "Chargement...",
  error: "Erreur",
  success: "Succès",
};
